import axios from 'axios'
import QS from 'qs';
export function post(url, params) {
     var token=getToken();
      params['token']=token;
    
    
    return new Promise((resolve, reject) => {
       
         axios.post(url,QS.stringify(params))
        .then(res => {
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}

export function get(url, params){    
    var token=getToken();
    params['token']=token;
  
    // alert(JSON.stringify(params))
    return new Promise((resolve, reject) =>{        
        axios.get(url, {            
            params: params        
        }).then(res => {
           
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)        
    })    
});}

function getToken(){

    const user_data=localStorage.getItem("sh_admin_user_data")
    let json_data={}
    if(user_data!== null){
   
     json_data=JSON.parse(user_data)
    
     
    }
  
    return json_data.token
}
